
import { NotificationPriority, NotificationType, Notification } from './types';
import { toast } from 'sonner';

// Generate a notification ID
export const generateId = () => `notif_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

// Get notification priority based on days left
export const getNotificationPriority = (daysLeft: number, type: NotificationType): NotificationPriority => {
  if (type === 'system-error') return 'urgent'; // Always urgent for errors
  if (daysLeft <= 1) return 'urgent';
  if (daysLeft <= 3) return 'important';
  return 'informational';
};

// Mock SMS notification function (would be replaced with a real SMS service)
export const sendSMSNotification = (phoneNumber: string, message: string) => {
  // In a real implementation, this would call an SMS API service
  console.log(`SMS would be sent to ${phoneNumber}: ${message}`);
  
  // Show toast to represent the SMS being sent (for demo purposes)
  toast("SMS Notification Sent", {
    description: `An SMS would be sent to ${phoneNumber}`
  });
};

// Create a notification object
export const createNotificationObject = ({
  id,
  title,
  message,
  type,
  priority,
  studentId,
  programTitle,
  dueDate,
  errorDetails, // For system errors
  hasAction = false,
  actionText = "",
  metadata = {}
}: {
  id: string;
  title: string;
  message: string;
  type: NotificationType;
  priority: NotificationPriority;
  studentId?: number;
  programTitle?: string;
  dueDate?: Date;
  errorDetails?: string;
  hasAction?: boolean;
  actionText?: string;
  metadata?: Record<string, any>;
}): Notification => {
  return {
    id,
    title,
    message,
    timestamp: new Date(),
    read: false,
    type,
    priority,
    studentId,
    programTitle,
    dueDate,
    errorDetails,
    hasAction,
    actionText,
    metadata
  };
};

// Generate payment action URL for notifications
export const generatePaymentActionUrl = (
  paymentType: 'student-fee' | 'teacher-salary', 
  id: number | string
): string => {
  if (paymentType === 'student-fee') {
    return `/students/${id}/payment`;
  } else {
    return `/teachers/${id}/payment`;
  }
};

